<div class="modal-body width-600 height-600">
  <div class="layout-auto-1-auto">
    <span class="modal-header">
      {{editMode ? 'Bewertung bearbeiten' : 'Neue Bewertung'}} für {{oeName}}
    </span>

    <div class="content">
      <ng-container *ngIf="!editMode">
        <div class="grid cols-2">
          <exg-select [list]="data.AvailableDateList" listdisplay="bmqYear" [caption]="'Jahr'" [ngModel]="yearIndex"
                      (ngModelChange)="changeYear($event)"></exg-select>
          <exg-select [list]="monthselectorList" listdisplay="monthName" [caption]="'Monat'" [ngModel]="monthIndex"
                      (ngModelChange)="changeMonth($event)"></exg-select>
        </div>
      </ng-container>
      <ng-container *ngIf="editMode">
        <div class="grid cols-4">
          <div>Jahr:</div>
          <div>{{BonusMalusQuestionare.bmqYear}}</div>
          <div>Monat:</div>
          <div>{{BonusMalusQuestionare.bmqMonth}}</div>
        </div>
      </ng-container>
      <div>&nbsp;</div>
      <!--      <exg-input [minlength]="1" min="1" max="12" [required]="true" type="number"-->
      <!--                 [(ngModel)]="BonusMalusQuestionare.bmqMonth"-->
      <!--                 [caption]="'Monat'" class="span-4"-->
      <!--                 name="bmqMonth">-->
      <!--      </exg-input>-->
      <!--      <exg-input [minlength]="1" [required]="true" type="number"-->
      <!--                 [(ngModel)]="BonusMalusQuestionare.bmqYear"-->
      <!--                 [caption]="'Jahr'" class="span-4"-->
      <!--                 name="bmqMonth">-->
      <!--      </exg-input>-->

      <div class="grid-auto-1 md3-surface md3-card-on-surface">
        <ng-container>
          <div>Berichtsqualität:</div>
          <div>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqReportQuality >= -2)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqReportQuality = -2"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqReportQuality >= -1)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqReportQuality = -1"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqReportQuality >= -0)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqReportQuality = 0"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqReportQuality >= 1)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqReportQuality = 1"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqReportQuality == 2)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqReportQuality = 2"></i>
            ({{BonusMalusQuestionare.bmqReportQuality}})
          </div>
        </ng-container>
        <ng-container>
          <div>Einsatzbereitschaft:</div>
          <div>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqOperationalReadiness >= -2)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqOperationalReadiness = -2"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqOperationalReadiness >= -1)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqOperationalReadiness = -1"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqOperationalReadiness >= -0)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqOperationalReadiness = 0"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqOperationalReadiness >= 1)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqOperationalReadiness = 1"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqOperationalReadiness == 2)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqOperationalReadiness = 2"></i>
            ({{BonusMalusQuestionare.bmqOperationalReadiness}})
          </div>
        </ng-container>
        <ng-container>
          <div>Bearbeitungsqualität:</div>
          <div>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqProcessingQuality >= -2)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqProcessingQuality = -2"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqProcessingQuality >= -1)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqProcessingQuality = -1"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqProcessingQuality >= -0)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqProcessingQuality = 0"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqProcessingQuality >= 1)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqProcessingQuality = 1"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqProcessingQuality == 2)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqProcessingQuality = 2"></i>
            ({{BonusMalusQuestionare.bmqProcessingQuality}})
          </div>
        </ng-container>
        <ng-container>
          <div>Fristen-/SLA-Einhaltung:</div>
          <div>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqSLAObservance >= -2)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqSLAObservance = -2"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqSLAObservance >= -1)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqSLAObservance = -1"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqSLAObservance >= -0)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqSLAObservance = 0"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqSLAObservance >= 1)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqSLAObservance = 1"></i>
            <i class="search-action fa-star {{(BonusMalusQuestionare.bmqSLAObservance == 2)?'fas':'far'}}"
               (click)="BonusMalusQuestionare.bmqSLAObservance = 2"></i>
            ({{BonusMalusQuestionare.bmqSLAObservance}})
          </div>
        </ng-container>
      </div>
      <div class="md3-surface md3-card-on-surface" *ngIf="excSecurity.isFeatured('BONUSMALUSEDIT')">
        <exg-textarea [(ngModel)]="BonusMalusQuestionare.bmqComment" caption="Kommentar"></exg-textarea>
      </div>
      <!--    <exg-input [min]="-2" [max]="+2"  [required]="true" type="number"-->
      <!--               [(ngModel)]="BonusMalusQuestionare.bmqReportQuality"-->
      <!--               [caption]="'Berichtsqualität'" class="span-4"-->
      <!--               name="bmqReportQuality">-->
      <!--    </exg-input>-->
      <!--    <exg-input [min]="-2" [max]="+2"  [required]="true" type="number"-->
      <!--               [(ngModel)]="BonusMalusQuestionare.bmqProcessingQuality"-->
      <!--               [caption]="'Bearbeitungsqualität'" class="span-4"-->
      <!--               name="bmqProcessingQuality">-->
      <!--    </exg-input>-->
      <!--    <exg-input [min]="-2" [max]="+2" [required]="true" type="number"-->
      <!--               [(ngModel)]="BonusMalusQuestionare.bmqOperationalReadiness"-->
      <!--               [caption]="'Einsatzbereitschaft'" class="span-4"-->
      <!--               name="bmqOperationalReadiness">-->
      <!--    </exg-input>-->
      <!--    <exg-input [min]="-2" [max]="+2" [required]="true" type="number"-->
      <!--               [(ngModel)]="BonusMalusQuestionare.bmqSLAObservance"-->
      <!--               [caption]="'Fristen-/SLA-Einhaltung'" class="span-4"-->
      <!--               name="bmqSLAObservance">-->
      <!--    </exg-input>-->
    </div>
    <div *ngIf="requestLock" style="color:var(--c-red-500)">Nach dem Abschluss kann die Bewertung nicht mehr geändert
      werden.
    </div>
    <div class="spawn-modal-actions">
      <ng-container *ngIf="!requestLock">
        <button (click)="close()" class="md-btn">
          Abbrechen
        </button>
        <button (click)="save()" *ngIf="saveAllowed" [disabled]="disabled" class="md-btn">
          {{editMode ? 'Ändern' : 'Erstellen'}}
        </button>
        <button (click)="requestLock = true" *ngIf="saveAllowed && excSecurity.isFeatured('BONUSMALUSLOCK')" [disabled]="disabled" class="md-btn">
          {{editMode ? 'Ändern und abschließen' : 'Erstellen und abschließen'}}
        </button>
      </ng-container>

      <ng-container *ngIf="requestLock && saveAllowed && excSecurity.isFeatured('BONUSMALUSLOCK')">

        <button (click)="requestLock = false" class="md-btn">
          Abbrechen
        </button>
        <button (click)="save(true)"  [disabled]="disabled" class="md-btn">
          {{editMode ? 'Abschließen' : 'Abschließen'}}
        </button>

      </ng-container>
    </div>

  </div>
</div>
